import { updateStaff } from '@/app/services/staff/staff';
import * as Actions from '@/app/store/actions';
import { CircularProgress } from '@material-ui/core';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import './DisableConfirmDialog.css';
import GradientButton from '@shared/components/GradientButton';

const DisableConfirmDialog = ({ row, setRefresh, refresh }) => {
	const [isRequesting, setIsRequesting] = useState(false);
	const dispatch = useDispatch();

	const disableStaff = () => {
		setIsRequesting(true);

		const payload = {
			first_name: row.first_name,
			last_name: row.last_name,
			email: row.email,
			title: row.title,
			position_type: row.position_type,
			admin: row.admin,
			status: row.status ? 0 : 1,
		};

		updateStaff(payload, row.id)
			.then(() => {
				dispatch(
					Actions.showMessage({
						message: row.status ? 'Staff Disabled Successfully' : 'Staff Enabled Successfully',
						autoHideDuration: 1500,
						variant: 'success',
					})
				);
				setRefresh(!refresh);
				dispatch(Actions.closeDialog());
			})
			.catch((error) => {
				dispatch(
					Actions.showMessage({
						message: error.response?.data?.message || 'Failed to Update Staff Status',
						autoHideDuration: 1500,
						variant: 'error',
					})
				);
				dispatch(Actions.closeDialog());
			})
			.finally(() => {
				setIsRequesting(false);
			});
	};

	return (
		<div className="popup">
			<div>
				<div className="icon-span">
					<h2>!</h2>
				</div>
				<h1 className="disable-text">
					Are you sure you want to {row.status ? 'disable' : 'enable'} {row.first_name} {row.last_name}?
				</h1>
				{isRequesting ? (
					<CircularProgress size={35} />
				) : (
					<div className="flex gap-16 justify-center">
						<GradientButton
							className="no-disable-btn"
							onClick={() => dispatch(Actions.closeDialog())}
							type="button"
							variant="secondary"
						>
							No
						</GradientButton>
						<GradientButton className="no-disable-btn" onClick={disableStaff} type="button" variant="blurple">
							Yes
						</GradientButton>
					</div>
				)}
			</div>
		</div>
	);
};

export default DisableConfirmDialog;
